import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  .new-colaborator-container {
    display: flex;
    flex-wrap: wrap;

    padding: 5px 10px;

    width: 80%;
    gap: 24px;
  }

  .new-colaborator-title {
    width: 100%;
    color: #000;

    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    @media only screen and (min-width: 1441px) {
      font-size: 18px;
    }
  }

  .new-colaborator-instruction {
    color: #070707;
    font-family: Roboto;
    font-size: 13px;
    font-style: normal;
    font-weight: 300;
    line-height: 26px;
    @media only screen and (min-width: 1441px) {
      font-size: 15px;
    }
  }

  .new-colaborator-subtitle {
    display: flex;
    align-items: center;

    gap: 16px;
    margin-top: 20px;
    margin-bottom: 20px;

    img {
      width: 16px;
      height: 16px;
    }

    color: #070707;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.16px;
  }

  @media only screen and (max-width: 1440px) {
    .new-colaborator-container {
      width: 80%;
    }
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 15px;

  .selected-client-name {
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    width: 252px;
    padding: 13px;
    background-color: ${Theme.pallete.TERTIARY};
    border-radius: 5px;
    color: white;
  }
  .cliente-trash {
    width: 19px;
  }
  .trash-btn {
    background: none;
    border: none;
    padding: 2px;
    margin-left: 20px;
    cursor: pointer;
  }
  .trash-btn:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`
